export default "__VITE_ASSET__BNpIpKyL__"